import React from 'react';
import { formatInteger } from '../../common/formatHelper';
import { cn } from '../../common/utils';
import EmptyValueTag from './EmptyValueTag';

type UomProps = {
  uom?: string;
  value?: number;
  className?: string;
  classType?: string;
};

const UomTag: React.FC<UomProps> = props => {
  if (!props.uom) {
    return <EmptyValueTag />;
  }

  return (
    <span
      data-component="UomTag"
      // className={classNames(
      //   'group',
      //   'relative',
      //   'flex flex-1 items-center',
      //   'p-1',
      //   'text-xs',
      //   'rounded',
      //   { 'bg-menu-active text-menu-active-text': props.hasIssue },
      //   {
      //     'bg-app-panel-dark/50 text-menu-text':
      //       !props.transparent && !props.hasIssue,
      //   },
      //   props.className,
      // )}
      className={cn(
        'flex flex-1 text-right',
        'text-xxs m-px inline-flex rounded px-2 py-1',
        props.classType
          ? props.classType
          : 'bg-app-panel-dark/70 text-menu-text group-hover:text-menu-text group-hover:bg-app-panel-dark/30',
        props.className,
      )}
    >
      <span
        data-type="key"
        className={cn(
          'flex-1 whitespace-pre text-left opacity-50 ltr:mr-1 rtl:ml-1',
        )}
      >
        {props.uom}
      </span>

      {props.value && (
        <span data-type="value" className="flex-1 text-right">
          {props.value > 1000000
            ? formatInteger(props.value)
            : formatInteger(props.value)}
        </span>
      )}
    </span>
  );
};

export default UomTag;
